import { render, staticRenderFns } from "./NwxSnackbar.vue?vue&type=template&id=9c108ea2&scoped=true"
import script from "./NwxSnackbar.vue?vue&type=script&lang=js"
export * from "./NwxSnackbar.vue?vue&type=script&lang=js"
import style0 from "./NwxSnackbar.vue?vue&type=style&index=0&id=9c108ea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c108ea2",
  null
  
)

export default component.exports